import { createFileRoute } from '@tanstack/react-router';

import { PresentationShell } from '../features/presentations/presentation-shell';

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId',
)({ component: RouteComponent });

function RouteComponent() {
  const params = Route.useParams();
  return <PresentationShell {...params} />;
}
